/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_FormatterInputs */

const en_sidebar_formatter = /** @type {(inputs: Sidebar_FormatterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatter`)
};

const ko_sidebar_formatter = /** @type {(inputs: Sidebar_FormatterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포맷터`)
};

const ja_sidebar_formatter = /** @type {(inputs: Sidebar_FormatterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォーマッター`)
};

/**
* | output |
* | --- |
* | "Formatter" |
*
* @param {Sidebar_FormatterInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_formatter = /** @type {((inputs?: Sidebar_FormatterInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_FormatterInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_formatter(inputs)
	if (locale === "ko") return ko_sidebar_formatter(inputs)
	return ja_sidebar_formatter(inputs)
});